export const BREAK_EDGE_VALUE = 4;
